import { API, I18nt } from 'utils';
import cn from 'classnames';
import { SearchOutlined } from '@ant-design/icons';

import styles from './doctorView.module.less';
import { useAgendarCita } from 'pages/AgendarCita/AgendarCitaContext';
import { Doctor } from 'utils/interfaces';
import { Col, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';

const DoctorView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { doctors, dispatch, selectedDoctor, selectedCategory } = useAgendarCita();
  const [search, setSearch] = useState('');

  const onDoctorClick = (selectedDoctor: Doctor) => {
    dispatch({ type: 'setSelectedDoctor', payload: { selectedDoctor } });
  };

  const filteredDoctors = doctors.filter((doctor) => 
    doctor.nombreEstablecimiento.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || 
    doctor.nombreMedico.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  );

  useEffect(() => {
    setIsLoading(true);
    const getDoctors = async () => {
      const { data } = await API.getMedicos(selectedCategory?.idEspecialidad);
      dispatch({ type: 'setDoctorsList', payload: { doctors: data } });
      setIsLoading(false);
    };
    getDoctors();

  }, []);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.spinCont}>
          <Spin />
        </div>
      );
    }

    if (filteredDoctors.length === 0) {
      return (
        <div className={styles.place}>
          {I18nt('no_hay_Se_encontraron_resultados')}
        </div>
      );
    }

    return filteredDoctors.map((doc) => (
      <div
        key={doc.idMedico}
        className={cn(styles.place, {
          [styles.selected]:
            selectedDoctor?.idMedico ===
            doc.idMedico,
        })}
        onClick={() => onDoctorClick(doc)}
      >
        {`${doc.nombreMedico.toLocaleLowerCase()} - ${doc.nombreEstablecimiento.toLocaleLowerCase()}`}
      </div>
    ));
  };


  return (
    <>
    <Row justify='center'>
      <Col xs={24} lg={12}>
        <div className={styles.filterContainer}>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type='text'
            placeholder={I18nt('buscar_medico')}
          />
          <div className={styles.filterButton}>
            <SearchOutlined />
          </div>
        </div>
      </Col>
    </Row>
    <Row justify='center'>
      <Col xs={24} lg={12}>
        <section className={styles.placeSection}>
          <div className={styles.title}>
            {`${I18nt('medico_especialista_en')} ${selectedCategory?.nombreEspecialidad.toLocaleLowerCase()}`}
          </div>
          <div className={styles.placesContainer}>
            {renderContent()}{ }
          </div>
        </section>
      </Col>
    </Row>
    </>
  );
};

export default DoctorView;
